import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["sections", "fields", "values", "errors", "onAction", "isFormDisabled", "className", "isFetching", "scrollParentSelector", "loaderProps"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { defaultMemoize } from 'reselect';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import cx from 'classnames';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import FormBuilder from '../../organisms/FormBuilder';
import withEventSubmission from './withEventSubmission';
import { PopupContainerProvider } from '../../molecules/popover';
import SpinnerComponent from '../../molecules/SpinnerComponent';
import formActionTypes from '../../organisms/FormBuilder/constants/actionTypes';
var FormWithSubmission = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormWithSubmission, _PureComponent);
  var _super = _createSuper(FormWithSubmission);
  function FormWithSubmission() {
    var _this;
    _classCallCheck(this, FormWithSubmission);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getScrollParentSelector", defaultMemoize(function (scrollParentSelector) {
      return {
        scrollParentSelector: scrollParentSelector
      };
    }));
    return _this;
  }
  _createClass(FormWithSubmission, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onAction = this.props.onAction;
      onAction({
        type: formActionTypes.ON_FORM_INIT,
        payload: EMPTY_OBJECT
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        sections = _this$props.sections,
        fields = _this$props.fields,
        values = _this$props.values,
        errors = _this$props.errors,
        onAction = _this$props.onAction,
        isFormDisabled = _this$props.isFormDisabled,
        className = _this$props.className,
        isFetching = _this$props.isFetching,
        scrollParentSelector = _this$props.scrollParentSelector,
        loaderProps = _this$props.loaderProps,
        rest = _objectWithoutProperties(_this$props, _excluded);
      if (isFetching) {
        return /*#__PURE__*/React.createElement("div", _extends({}, loaderProps, {
          className: "flex-center full-width full-height"
        }), /*#__PURE__*/React.createElement(SpinnerComponent, null));
      }
      var formClassName = cx(className, {
        'is-disabled': isFormDisabled
      });
      return /*#__PURE__*/React.createElement(PopupContainerProvider, {
        value: this.getScrollParentSelector(scrollParentSelector)
      }, /*#__PURE__*/React.createElement(FormBuilder, _extends({}, rest, {
        sections: sections,
        fields: fields,
        values: values,
        errors: errors,
        className: formClassName,
        onAction: onAction
      })));
    }
  }]);
  return FormWithSubmission;
}(PureComponent);
_defineProperty(FormWithSubmission, "propTypes", {
  values: PropTypes.object,
  className: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  errors: PropTypes.object,
  fields: PropTypes.object.isRequired,
  sections: PropTypes.array.isRequired,
  isFormDisabled: PropTypes.bool,
  isFetching: PropTypes.bool,
  scrollParentSelector: PropTypes.string
});
_defineProperty(FormWithSubmission, "defaultProps", {
  values: EMPTY_OBJECT,
  className: EMPTY_STRING,
  errors: EMPTY_OBJECT,
  isFormDisabled: false,
  isFetching: false,
  scrollParentSelector: ''
});
export var FormBuilderWithScrollParentProvider = FormWithSubmission;
export default compose(withEventSubmission)(FormWithSubmission);